<template>
  <div class="router-area">
    <div class="router-innner inner-media-width yd-display-flex yd-alignItems">
      <div @click="$router.push('/')" title="返回首页">
        <a href="javascript:;">首页</a>
        <img
          class="router-arrow"
          src="../../assets/images/blackArrowRightIcon.png"
        />
      </div>
      <div
        @click="goRouter(item, index)"
        v-for="(item, index) in routerData"
        :key="index"
      >
        <a
          href="javascript:;"
          v-text="item.meta.title == '详情' ? title : item.meta.title"
        ></a>
        <img
          v-if="index !== routerData.length - 1"
          class="router-arrow"
          src="../../assets/images/blackArrowRightIcon.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      routerData: [],
      special: "", // 这个暂时用来保存一下列表的路由，因为呢，列表和详情是同级路由，所以进入详情后，没办法得到列表的路由了
      title: "",
    };
  },
  watch: {
    $route: "routerHandle",
  },
  mounted() {
    this.routerHandle();
    this.$root.Bus.$on("topNavbarArea", (content) => {
      this.title = content;
    });
  },
  methods: {
    // 处理路由显示逻辑
    routerHandle() {
      /*
          原因：列表和详情同处同级路由。
          解决：在详情的时候要局部导航要显示列表的路由。
         */
      let _this = this;
      let currentRouteName = _this.$route.name;
      const specialArr2 = ["NewsList", "DeviceList", "InfoList"];
      const specialArr3 = ["NewsDetails", "DeviceDetails", "InfoDetails"];
      _this.routerData = [];
      if (_this.special && specialArr3.includes(currentRouteName)) {
        _this.routerData.push(_this.special);
      }
      _this.$route.matched.forEach((item) => {
        if (
          JSON.stringify(item.meta) !== "{}" &&
          item.meta.title &&
          item.meta.titleIsShow
        ) {
          _this.routerData.push(item);
        }
        // 特殊处理
        if (
          specialArr2.includes(currentRouteName) &&
          specialArr2.includes(item.name)
        ) {
          _this.special = item;
        }
      });
    },
    // 路由跳转
    goRouter(item, index) {
      if (index === this.routerData.length - 1) return; // 最后一级不处理
      this.$router.push(item.path);
    },
  },
};
</script>

<style scoped>
.router-area {
  width: 100%;
  border-bottom: 1px solid #f5f5f5;
  background: #f8f8f8;
  box-sizing: border-box;
}
.router-area .router-innner {
  width: 74%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 2px 0;
  color: #333333;
  font-size: 12px;
  height: 32px;
  line-height: 32px;
}
.router-area .router-innner .router-arrow {
  width: 20px;
  height: 20px;
}
.router-area .router-innner a:hover {
  color: #2e81e1;
}
</style>



// WEBPACK FOOTER //
// src/components/topNavbarArea/index.vue